import _ from 'lodash'

/**
 * A simple stopwatch for tracking multiple timers across different processes
 */
export class StopWatchImpl {
  private timers: Map<string, { startTime: number; endTime?: number }> = new Map()

  public start(tag: string): void {
    if (this.timers.has(tag) && !this.timers.get(tag)?.endTime) {
      console.warn(`Stopwatch is already running:tag=${tag}`)
      return
    }
    this.timers.set(tag, { startTime: Date.now() })
    console.log(`Stopwatch started: tag=${tag}`)
  }

  public stop(tag: string, msg?: string): any {
    const timer = this.timers.get(tag)
    if (!timer) {
      console.warn(`No stopwatch found for tag "${tag}".`)
      return ''
    }
    timer.endTime = Date.now()
    const elapsedTime = this.getElapsedTimeMs(tag)
    console.log(`Stopwatch stopped: tag=${tag},time: ${elapsedTime}ms, msg=${msg}`)
    return elapsedTime
  }

  public getAllElapsedTimes(): Record<string, number> {
    return _.reduce(
      [...this.timers.keys()],
      (acc, key) => {
        _.set(acc, key, this.getElapsedTimeMs(key))
        return acc
      },
      {}
    )
  }

  private getElapsedTimeMs(tag: string): number | null {
    const timer = this.timers.get(tag)
    if (!timer) {
      console.warn(`No tag found:tag=${tag}`)
      return null
    }
    const endTime = timer.endTime ?? Date.now()
    return endTime - timer.startTime // Time in milliseconds
  }
}

export const StopWatch = new StopWatchImpl()
